var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 0.166992H2.16667C1.25 0.166992 0.5 0.916992 0.5 1.83366V11.8337C0.5 12.7503 1.25 13.5003 2.16667 13.5003H6.33333V14.3337C6.33333 14.792 6.70833 15.167 7.16667 15.167H12.1667C12.625 15.167 13 14.792 13 14.3337V13.5003H17.1667C18.0833 13.5003 18.8333 12.7503 18.8333 11.8337V1.83366C18.8333 0.916992 18.0833 0.166992 17.1667 0.166992ZM16.3333 11.8337H3C2.54167 11.8337 2.16667 11.4587 2.16667 11.0003V2.66699C2.16667 2.20866 2.54167 1.83366 3 1.83366H16.3333C16.7917 1.83366 17.1667 2.20866 17.1667 2.66699V11.0003C17.1667 11.4587 16.7917 11.8337 16.3333 11.8337ZM14.6667 4.33366H7.16667C6.70833 4.33366 6.33333 4.70866 6.33333 5.16699C6.33333 5.62533 6.70833 6.00033 7.16667 6.00033H14.6667C15.125 6.00033 15.5 5.62533 15.5 5.16699C15.5 4.70866 15.125 4.33366 14.6667 4.33366ZM14.6667 7.66699H7.16667C6.70833 7.66699 6.33333 8.04199 6.33333 8.50033C6.33333 8.95866 6.70833 9.33366 7.16667 9.33366H14.6667C15.125 9.33366 15.5 8.95866 15.5 8.50033C15.5 8.04199 15.125 7.66699 14.6667 7.66699ZM5.5 4.33366H3.83333V6.00033H5.5V4.33366ZM5.5 7.66699H3.83333V9.33366H5.5V7.66699Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigital);
export default __webpack_public_path__ + "static/media/Digital.0e693124.svg";
export { ForwardRef as ReactComponent };